import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...props }) => {
  const loggedIn = localStorage.getItem("session");

  return (
    <Route
      {...props}
      render={(props) =>
        loggedIn ? <Component {...props} /> : <Redirect to="/auth/signin" />
      }
    ></Route>
  );
};

export default PrivateRoute;
